import React from "react";
import { TextInputCard } from "@deliverr/ui-facility/lib-facility/flow/cards";

export interface ClosePalletScanPalletSuccessCardProps {
  palletLabelId: string;
  newest?: boolean;
}

export const ClosePalletScanPalletSuccessCard: React.FC<ClosePalletScanPalletSuccessCardProps> = ({
  palletLabelId,
  newest,
}) => (
  <TextInputCard
    icon="check"
    accentColor="GREEN"
    title="Closed pallet"
    value={palletLabelId}
    newest={newest}
    disabled
  />
);
